module.exports = __webpack_public_path__ + "img/logo-cast-gram.2d875ddd.svg";